export const _en = {
    addButton: {
        label: "Add skill"
    },
    toggleDeleted: {
        label: "Show deleted data"
    },
    dialog: {
        new: {
            title: "Add service"
        }
    }
};


export const _fr = {
    addButton: {
        label: "Service"
    },
    toggleDeleted: {
        label: "Afficher les élements archivés"
    },
    dialog: {
        new: {
            title: "Ajout d'un service"
        }
    }
};